export default {
  'consumption.co2': 'Kombinované emise CO2',
  'consumption.energy': 'Kombinovaná spotřeba energie',
  'consumption.fuel': 'Kombinovaná spotřeba paliva',
  'footnotes.local': '',
  'footnotes.wltp':
    'Uvedené hodnoty byly stanoveny podle předepsané metody měření. Jedná se o „hodnoty CO2 WLTP“ ve smyslu čl. 2 č. 3 prováděcího nařízení (EU) 2017/1153. Na základě těchto hodnot byly vypočítány hodnoty spotřeby paliva. Spotřeba elektrické energie byla stanovena na základě VO 683/2008 / EG. Informace se netýkají jediného vozidla a nejsou součástí nabídky, ale slouží pouze pro účely srovnání mezi různými typy vozidel. Hodnoty se liší v závislosti na zvoleném volitelném vybavení.',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix':
    'Další informace o spotřebě paliva a emisích CO2 u nových osobních automobilů Vám poskytne autorizovaný prodejce Mercedes-Benz.',
  'search.input.label': 'Váš hledaný výraz / OnlineCode konfigurátoru',
  'search.result.buy-online': 'Koupit online',
  'search.results': 'Nebyly nalezeny žádné výsledky | {count} výsledek hledání | Počet výsledků vyhledávání: {count}',
  'search.results.count': 'Počet výsledků vyhledávání: {count}',
  'search.results.backup': 'Nebyly nalezeny žádné přesné shody. Zobrazit související stránky:',
  'search.results.none.summary':
    'Pro tento hledaný výraz nejsou k dispozici žádné výsledky vyhledávání. Zkuste to prosím znovu s jiným výrazem.',
  'search.show-more': 'Zobrazit více',
  'search.unavailable': 'Vyhledávání není aktuálně k dispozici.',
  'search.result.new': 'Nové',

  'input.placeholder': 'Váš hledaný výraz / OnlineCode konfigurátoru',

  'suggestions.all_search_results': 'Všechny výsledky vyhledávání',
  'suggestions.all_search_results_for': 'Všechny výsledky vyhledávání',
  'suggestions.in': 'u',

  all: 'Všechny',
  UCOS: 'Ojeté vozidlo | Internetový obchod',
  PASSENGER_CARS: 'Osobní vozidlo',
  VANS: 'Dodávková vozidla',
  NCOS: 'Nové vozidlo | Internetový obchod',
  VIDEO: 'Videa',
  DEALER_LOCATOR: 'Vyhledávání prodejců',
  CONFIGURATOR: 'Rezervovat zkušební jízdu',
  TEST_DRIVE: 'Zkušební jízda',
  VEHICLE_SEARCH: 'Vyhledávání ojetých vozidel',
  COLLECT: 'Kolekce a příslušenství',
  CONNECT: 'Mercedes me Store',

  'search.result.consumption': 'Spotřeba',
  'watch.video': 'Zhlédnout video',
  'input.recently': 'Nedavno pretražno',
  'input.help.title': 'Co byste měli hledat?',
  'input.help.text':
    'Vyhledávání pomocí typů vozidel, modelů, konfiguračních kódů nebo PŘÍSLUŠENSTVÍ, dalších produktů a informací',

  'search.result.grid': 'Mřížka',
  'search.result.list': 'Seznam',

  //No results found
  'support.check': 'Zkontrolujte, zda nedošlo k překlepu, nebo to zkuste znovu s jiným výrazem.',
  'support.no.results': 'Pro tento výraz nejsou k dispozici žádné výsledky vyhledávání.',
  'support.no.results.term': 'Nebyly nalezeny žádné výsledky',
  'support.chat': 'Nemůžete najít, co hledáte? Využijte naši online',
  'support.chat.with.us': 'podporu prostřednictvím chatu.',

  'search.results.offer': 'Oblíbené nabídky pro "{query}":',
};
